import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { BRAND } from '../../theme/brandTheme';

/** Dashboard page header — matches landing typography */
const DashboardHeader = ({ user }) => (
  <Box sx={{ mb: 4 }}>
    <Chip
      label="👋 hype CRO Dashboard"
      size="small"
      sx={{
        mb: 1.5,
        bgcolor: BRAND.badgeBg,
        color: '#fff',
        border: `1px solid ${BRAND.badgeBorder}`,
        fontFamily: BRAND.fontFamily,
        fontWeight: 500,
      }}
    />
    <Typography
      variant="h4"
      component="h1"
      gutterBottom
      sx={{ fontWeight: 700, color: BRAND.purple, fontFamily: BRAND.fontFamily }}
    >
      Test Portföyünüz
    </Typography>
    <Typography
      variant="body1"
      sx={{ fontWeight: 400, color: BRAND.textMuted, fontFamily: BRAND.fontFamily }}
    >
      Hoş geldiniz, {user?.username || 'Kullanıcı'}. AB test raporlarınızı görüntüleyin ve yönetin.
    </Typography>
  </Box>
);

export default DashboardHeader;
